var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.editContent),callback:function ($$v) {_vm.editContent=$$v},expression:"editContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }